import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

const STORAGE_KEY = "useOldEditor";

function getUseOldEditor(): boolean {
  const value = localStorage.getItem(STORAGE_KEY);
  return value === "true";
}

function setUseOldEditor(useOld: boolean): void {
  localStorage.setItem(STORAGE_KEY, String(useOld));
}

export function useFlowEditorPreference(): [boolean, () => void] {
  const [useOld, setUseOld] = useState(getUseOldEditor);
  const navigate = useNavigate();

  const toggle = useCallback(() => {
    const newValue = !useOld;
    setUseOld(newValue);
    setUseOldEditor(newValue);

    const currentPath = window.location.pathname;
    navigate(currentPath, { replace: true });
  }, [useOld, navigate]);

  return [!useOld, toggle];
}

export function isNewFlowEditorEnabled(): boolean {
  return !getUseOldEditor();
}
